import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";

// ----------- Async Thunk (TEST SMTP settings) -----------
export const testSmtpSettings = createAsyncThunk(
  "smtpSettings/test",
  async (data, thunkAPI) => {
    try {
      const response = await api.post("/dashboard/general-settings/test-smtp-settings", data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Slice -----------
const testSmtpSettingsSlicer = createSlice({
  name: "testSmtpSettings",
  initialState: {
    data: null,
    loading: false,
    error: null,
    successMessage: "",
  },
  reducers: {
    clearTestSmtpSettingsState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(testSmtpSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(testSmtpSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(testSmtpSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTestSmtpSettingsState } = testSmtpSettingsSlicer.actions;
export default testSmtpSettingsSlicer.reducer;